import Link from "next/link";

export const ThirdBanner = () => {
  return (
    <Link href="/busca">
      <div className="relative h-[104vw] max-h-[25.25rem] w-full">
        {/* ===== < lg: empilhado — bloco de texto (cor sólida) em cima + arte embaixo (traços auto-contidos).
            PLACEHOLDER de cor do bloco: #FFFFFF (borda superior da arte). ===== */}
        <div className="flex h-full w-full flex-col bg-white lg:hidden">
          <div className="px-4 pb-2 pt-3 text-center">
            <p className="secondary-font text-[1.125rem] font-extrabold !leading-[1.5rem] text-banner-dark">
              A <span className="underline decoration-2 underline-offset-4">MAIS AVANÇADA TECNOLOGIA</span> DO MUNDO AO
              SEU ALCANCE.
            </p>
            <p className="secondary-font mx-auto mt-1 w-4/5 text-[0.75rem] font-light !leading-[1rem] tracking-wide text-banner-gray">
              A única empresa que personaliza <span className="font-bold">todos os tecidos</span> tecnológicos do
              Brasil.
            </p>
          </div>
          <div
            className="w-full flex-1 bg-center bg-no-repeat"
            style={{
              backgroundImage: "url('/images/home/main_carousel/banner_mobile_tecnologia.png')",
              backgroundSize: "min(80%, 384px) auto",
            }}
          />
        </div>

        {/* ===== ≥ lg: layout panorâmico (arte larga + texto sobreposto à esquerda) ===== */}
        <div className="hidden lg:absolute lg:inset-0 lg:block">
          <div className="absolute left-0 top-0 h-1/2 w-1/2 bg-base-white" />
          <div className="absolute left-0 top-1/2 h-1/2 w-1/2 bg-[#F0F0F0]" />
          <div className="relative z-0 flex h-full w-full flex-col bg-[url('/images/home/main_carousel/banner_desktop_tecnologia.png')] bg-right bg-[length:auto_100%] bg-no-repeat">
            <div className="z-10 mb-2 ml-4 mt-5 flex h-full w-1/2 flex-col justify-between px-3">
              <div className="secondary-font w-full text-start text-[2rem] font-extrabold !leading-[3.75rem] tracking-widest text-banner-dark">
                A <span className="underline decoration-2 underline-offset-4">MAIS AVANÇADA TECNOLOGIA</span> DO MUNDO
                AO SEU ALCANCE.
              </div>
              <div className="secondary-font mb-7 mt-1 w-full text-start text-[1.25rem] font-normal !leading-[1.5rem] tracking-wide text-banner-gray">
                A única empresa que personaliza <span className="font-bold">todos os tecidos</span> tecnológicos do
                Brasil.
              </div>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};
